import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import ikea from 'ikea-jssdk';

var PLATFORM;
(function (PLATFORM) {
  PLATFORM["APP"] = "APP";
  PLATFORM["SMP"] = "SMP";
  PLATFORM["IKEA"] = "IKEA";
  PLATFORM["H5"] = "H5";
})(PLATFORM || (PLATFORM = {}));
function getCityInApp() {
  return _getCityInApp.apply(this, arguments);
}
function _getCityInApp() {
  _getCityInApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _window$flutter_inapp;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('window.flutter_inappwebview', window.flutter_inappwebview);
            if (window.flutter_inappwebview) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", null);
          case 3:
            _context2.prev = 3;
            if (!(typeof ((_window$flutter_inapp = window.flutter_inappwebview) === null || _window$flutter_inapp === void 0 ? void 0 : _window$flutter_inapp.callHandler) === 'function')) {
              _context2.next = 11;
              break;
            }
            console.log('获取native city成功');
            _context2.next = 8;
            return window.flutter_inappwebview.callHandler('getCity');
          case 8:
            return _context2.abrupt("return", _context2.sent);
          case 11:
            console.log('获取native city失败');
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              window.addEventListener("flutterInAppWebViewPlatformReady", /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
                  var cityInfo;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          console.log('等待初始化获取城市');
                          _context.next = 3;
                          return window.flutter_inappwebview.callHandler('getCity');
                        case 3:
                          cityInfo = _context.sent;
                          console.log('获取城市成功', JSON.stringify(cityInfo));
                          resolve(cityInfo);
                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            }));
          case 13:
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            console.log('getCity:', _context2.t0);
            return _context2.abrupt("return", null);
          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15]]);
  }));
  return _getCityInApp.apply(this, arguments);
}
function getAddressInfo() {
  return _getAddressInfo.apply(this, arguments);
}
function _getAddressInfo() {
  _getAddressInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _yield$ikea$getAddres, type, value, zipCode, province, city;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return ikea.getAddressInfo();
          case 3:
            _yield$ikea$getAddres = _context3.sent;
            type = _yield$ikea$getAddres.type;
            value = _yield$ikea$getAddres.value;
            console.log('smp address v1.8.4 type value', type, value);
            if (!(type === 'success')) {
              _context3.next = 10;
              break;
            }
            zipCode = value.zipCode, province = value.province, city = value.city;
            return _context3.abrupt("return", {
              zipcode: zipCode,
              province: province,
              city: city
            });
          case 10:
            return _context3.abrupt("return", null);
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", null);
          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));
  return _getAddressInfo.apply(this, arguments);
}
function getCity() {
  return _getCity.apply(this, arguments);
}
function _getCity() {
  _getCity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var info, platform;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            info = null;
            _context4.next = 3;
            return whichPlatform();
          case 3:
            platform = _context4.sent;
            if (!(platform === PLATFORM.APP)) {
              _context4.next = 8;
              break;
            }
            _context4.next = 7;
            return getCityInApp();
          case 7:
            info = _context4.sent;
          case 8:
            if (!(platform === PLATFORM.SMP)) {
              _context4.next = 12;
              break;
            }
            _context4.next = 11;
            return getAddressInfo();
          case 11:
            info = _context4.sent;
          case 12:
            return _context4.abrupt("return", info);
          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getCity.apply(this, arguments);
}
function whichPlatform() {
  return _whichPlatform.apply(this, arguments);
}
function _whichPlatform() {
  _whichPlatform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var platformValue, res, _res$value, _res$value$platform, platform;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            platformValue = PLATFORM.H5;
            _context5.prev = 1;
            _context5.next = 4;
            return ikea.currentPlatform();
          case 4:
            res = _context5.sent;
            _res$value = res.value;
            _res$value = _res$value === void 0 ? {} : _res$value;
            _res$value$platform = _res$value.platform, platform = _res$value$platform === void 0 ? '' : _res$value$platform;
            _context5.t0 = platform;
            _context5.next = _context5.t0 === 'iOS' ? 11 : _context5.t0 === 'ANDROID' ? 11 : _context5.t0 === 'WechatMiniprogram' ? 13 : _context5.t0 === 'PcWeb' ? 15 : _context5.t0 === 'MobileWeb' ? 15 : _context5.t0 === 'unknown' ? 17 : 17;
            break;
          case 11:
            platformValue = PLATFORM.APP;
            return _context5.abrupt("break", 19);
          case 13:
            platformValue = PLATFORM.SMP;
            return _context5.abrupt("break", 19);
          case 15:
            platformValue = PLATFORM.IKEA;
            return _context5.abrupt("break", 19);
          case 17:
            platformValue = PLATFORM.H5;
            return _context5.abrupt("break", 19);
          case 19:
            _context5.next = 24;
            break;
          case 21:
            _context5.prev = 21;
            _context5.t1 = _context5["catch"](1);
            console.log(_context5.t1);
          case 24:
            return _context5.abrupt("return", platformValue);
          case 25:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 21]]);
  }));
  return _whichPlatform.apply(this, arguments);
}

export { PLATFORM, getAddressInfo, getCity, whichPlatform };
